var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.4375,
    width: 44.4138,
    height: 44.4138,
    rx: 7.4023,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9874 11.541C17.0229 11.5368 19.9526 12.6354 22.2122 14.6253V33.7479C19.9526 31.758 17.0229 30.6594 13.9874 30.6636C12.0603 30.6636 11.0968 30.6636 10.6711 30.3912C10.4155 30.2276 10.3111 30.1231 10.1475 29.8675C9.875 29.4419 9.875 28.6824 9.875 27.1634V15.7396C9.875 13.9781 9.875 13.0974 10.552 12.3835C11.229 11.6695 11.922 11.6327 13.3081 11.559C13.533 11.5471 13.7595 11.541 13.9874 11.541Z",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4358 11.541C27.4002 11.5368 24.4705 12.6354 22.2109 14.6253V33.7479C24.4705 31.758 27.4002 30.6594 30.4358 30.6636C32.3628 30.6636 33.3263 30.6636 33.752 30.3912C34.0076 30.2276 34.112 30.1231 34.2756 29.8675C34.5481 29.4419 34.5481 28.6824 34.5481 27.1634V15.7396C34.5481 13.9781 34.5481 13.0974 33.8712 12.3835C33.1941 11.6695 32.5011 11.6327 31.115 11.559C30.8901 11.5471 30.6636 11.541 30.4358 11.541Z",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.d88aa5318efc98ea1fca1b09187d47d1.svg";
export { ForwardRef as ReactComponent };